// ============================================================
// HABIT OS — "So prüfen wir"
// Offene Methodik der Etikett-Analyse und wie wir Geld verdienen.
// Werte kommen aus src/data/hoechstmengen.js (gleiche Quelle wie der Prompt).
// ============================================================

import React from "react";
import {
  HOECHSTMENGEN,
  HOECHSTMENGEN_QUELLEN,
  HOECHSTMENGEN_STAND,
  AENDERUNGSVERLAUF,
} from "../data/hoechstmengen";

export function MethodSheet({ Z, onClose }) {
  const font = "'Plus Jakarta Sans', sans-serif";
  const h = { fontFamily: "'Manrope', sans-serif", fontSize: 15, fontWeight: 600, color: Z.onSurface, margin: "20px 0 8px" };
  const p = { fontSize: 13, color: Z.onSurfaceVariant, lineHeight: 1.6, margin: "0 0 8px", fontFamily: font };
  const link = { color: Z.primary, textDecoration: "underline", wordBreak: "break-word" };

  return (
    <div style={{ position: "fixed", inset: 0, background: "rgba(25,28,24,0.6)", zIndex: 1000, display: "flex", alignItems: "flex-end" }} onClick={onClose}>
      <div role="dialog" aria-label="So prüfen wir" style={{ background: Z.surface, width: "100%", maxHeight: "92vh", borderRadius: "24px 24px 0 0", display: "flex", flexDirection: "column", overflow: "hidden" }} onClick={e => e.stopPropagation()}>
        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "14px 16px 8px", flexShrink: 0 }}>
          <div style={{ width: 32 }} />
          <div style={{ width: 36, height: 4, borderRadius: 2, background: Z.outlineVariant }} />
          <button onClick={onClose} aria-label="Schließen" style={{ width: 32, height: 32, borderRadius: "50%", border: "none", background: Z.surfaceContainerHigh || Z.surfaceContainer, color: Z.onSurfaceVariant, fontSize: 16, cursor: "pointer" }}>✕</button>
        </div>

        <div style={{ overflowY: "auto", padding: "0 20px 40px", WebkitOverflowScrolling: "touch" }}>
          <h3 style={{ fontFamily: "'Manrope', sans-serif", fontSize: 18, fontWeight: 500, color: Z.onSurface, margin: "0 0 8px" }}>So prüfen wir</h3>

          <h4 style={h}>Was die Etikett-Analyse macht</h4>
          <p style={p}>Die KI liest vom Foto ab, was auf dem Etikett steht: Stoff, Form und Menge pro empfohlener Tagesportion. Jede Menge vergleichen wir mit den Höchstmengen-Empfehlungen des Bundesinstituts für Risikobewertung (BfR) für Nahrungsergänzungsmittel.</p>
          <p style={p}>„Im Rahmen“ heißt: höchstens so viel wie empfohlen. „Über BfR-Empfehlung“ heißt: mehr — dann bitte ärztlich abklären. „Unklar“ heißt: Die Menge ist nicht lesbar oder für den Stoff gibt es in unserer Liste keinen Wert.</p>

          <h4 style={h}>Was wir bewusst nicht tun</h4>
          <p style={p}>Wir vergeben keine Punkte oder Noten für Produkte oder Marken, geben keine Dosierungs- oder Einnahmeempfehlungen und versprechen keine Wirkung. Die Analyse ersetzt keine ärztliche oder pharmazeutische Beratung. Die KI kann sich verlesen — prüfe wichtige Werte auf dem Etikett selbst.</p>

          <h4 style={h}>Höchstmengen, die wir verwenden</h4>
          <p style={{ ...p, fontSize: 12 }}>Pro Tagesverzehrempfehlung eines Produkts, für Erwachsene. Stand: {HOECHSTMENGEN_STAND}.</p>
          <div style={{ border: `1px solid ${Z.outlineVariant}`, borderRadius: 12, overflow: "hidden" }}>
            {HOECHSTMENGEN.map((row, i) => (
              <div key={row.stoff} style={{ display: "flex", gap: 12, padding: "8px 12px", borderTop: i ? `1px solid ${Z.outlineVariant}` : "none", fontFamily: font, fontSize: 13, color: Z.onSurface, background: i % 2 ? Z.surfaceContainerLow : Z.surfaceContainerLowest }}>
                <span style={{ flex: 1 }}>
                  {row.stoff}
                  {row.hinweis && <span style={{ display: "block", fontSize: 11, color: Z.onSurfaceVariant }}>{row.hinweis}</span>}
                </span>
                <span style={{ fontWeight: 600, whiteSpace: "nowrap" }}>{row.menge}</span>
              </div>
            ))}
          </div>

          <h4 style={h}>Quellen</h4>
          {HOECHSTMENGEN_QUELLEN.map(q => (
            <p key={q.url} style={{ ...p, fontSize: 12 }}>
              <a href={q.url} target="_blank" rel="noopener noreferrer" style={link}>{q.titel}</a>
            </p>
          ))}

          <h4 style={h}>Womit wir Geld verdienen</h4>
          <p style={p}>Nach einer Analyse kannst du dir ein Produkt aus einem Partnerprogramm ansehen. Es ist als „Anzeige“ gekennzeichnet und erscheint nur, wenn du darauf tippst. Kaufst du über den Link, erhalten wir eine Provision; der Preis ändert sich für dich nicht.</p>
          <p style={p}>Die Provision hat keinen Einfluss auf die Analyse oder darauf, welches Produkt wir zeigen. Wir zeigen keine Partnerprodukte, wenn eine Menge über der BfR-Empfehlung liegt, und nie für Eisen oder Ashwagandha. Bezahlte Platzierungen gibt es nicht.</p>

          <h4 style={h}>Änderungsverlauf</h4>
          {AENDERUNGSVERLAUF.map(e => (
            <p key={e.datum} style={{ ...p, fontSize: 12 }}><strong style={{ color: Z.onSurface }}>{e.datum}:</strong> {e.text}</p>
          ))}
        </div>
      </div>
    </div>
  );
}
